export const attributes = {
  type: '類型',
  guest: '訪客',
  account: '帳號',
  user: '會員',
  user_id: '會員編號',
  user_name: '會員名稱',
  fullname: '姓名',
  author: '作者',
  email: '電子信箱',
  password: '密碼',
  comment: '說明',
  information: '資訊',
  passenger: '旅客',
  passenger_type: '旅客類型',
  area_management: '員工線別權限管理',
  ip_address: 'IP',
  cowell: '科威',

  modifier: '更新者',
  create_date: '建立日期',
  modify_date: '更新日期',
  function_name: '功能名稱',
  service_name: '服務名稱',

  ok: '好',
  clear: '清除',
  cancel: '取消',
  close: '關閉',
  delete: '刪除',
  delete_off: '無法刪除',
  delete_selected: '刪除已選取',
  remove: '移除',
  confirm: '確定',
  confirm_delete: '確定刪除？',
  confirm_void: '確定作廢？',
  confirm_delete_with_name: '確定刪除「{name}」？',
  confirm_remove: '確定移除',
  confirm_deprecated: '確定廢棄？',
  continue: '繼續',
  reset: '重設',
  select: '選取',
  selected: '已選取',
  not_selected: '未選取',
  select_all: '全選',
  setting: '設定',
  mobile_version: '手機版',
  and: '與',

  display_mode: '顯示模式',

  today: '今日',
  yesterday: '昨日',
  this_month: '本月',
  last_month: '上月',
  three_month: '近三月',
  next_month: '下個月',

  weekly: '每週',
  week: '星期',
  sun: '日',
  mon: '一',
  tue: '二',
  wen: '三',
  thr: '四',
  fri: '五',
  sat: '六',

  sunday: '星期日',
  monday: '星期一',
  tuesday: '星期二',
  wednesday: '星期三',
  thursday: '星期四',
  friday: '星期五',
  saturday: '星期六',

  start_date: '開始日期',
  start_time: '開始時間',
  end_date: '下架日期',
  end_time: '下架時間',
  date_range: '日期區間',

  id: '編號',
  status: '狀態',
  activation_status: '狀態',
  activation_type: '版型',
  shelve_status: '上架狀態',
  open_register: '開放報名',
  version: '版本',
  sort_drag: '拖曳排序',
  sort: '排序',
  is_menu: '是否為選單',
  icon: '圖示',
  logo: '商標',
  search: '搜尋',
  advance_search: '進階搜尋',
  searching: '搜尋中',
  not_found: '找不到',
  function: '功能',
  all: '全部',
  empty: '無資料',
  enabled: '啟用',
  disabled: '停用',
  shelve_on: '上架',
  shelve_off: '下架',
  publish: '發佈',
  published: '已發佈',
  unpublished: '未發佈',
  deprecated: '廢棄',
  yes: '是',
  no: '否',
  included: '含',
  excluded: '不含',
  want_display: '是否顯示？',
  display: '顯示',
  not_display: '不顯示',
  display_expired: '含過期團',
  not_display_expired: '不含過期團',
  hide: '隱藏',
  preview: '預覽',
  cover: '圖片',

  add: '新增',
  copy: '複製',
  import: '匯入',
  save: '儲存',
  save_as: '另存',
  edit: '編輯',
  update: '更新',
  restore: '回復',
  booking: '預約',
  next: '下一步',
  complete: '完成',
  data: '資料',
  update_data: '更新資料',
  modify: '修改',
  transfer: '轉團',
  add_succeed: '新增成功',
  update_succeed: '更新成功',
  modify_succeed: '修改成功',
  approve_succeed: '審核完成',
  reject_succeed: '退審完成',
  cancel_succeed: '銷帳完成',
  void_succeed: '作廢完成',
  cancel_apply_succeed: '取消申請完成',
  booking_succeed: '預約成功',
  booking_canceled: '預約取消成功',
  booking_cancel_failed: '預約取消失敗',
  gift_submit: '送審',
  gift_submit_succeed: '送審成功',
  gift_submit_failed: '送審失敗',
  update_main_price_succeed: '設定主打價成功',
  update_main_plan_succeed: '設定主打方案成功',
  delete_succeed: '刪除成功',
  remove_succeed: '移除成功',
  deprecate_succeed: '廢棄成功',
  add_failed: '新增失敗',
  update_failed: '更新失敗',
  modify_failed: '修改失敗',
  void_failed: '作廢失敗',
  delete_failed: '刪除失敗',
  remove_failed: '移除失敗',
  deprecate_failed: '廢棄失敗',
  booking_failed: '預約失敗',
  empty_log: '無紀錄',
  update_cost_data: '更新價格資料',
  modify_time: '修改日期',
  send_mail: '寄信',

  code: '代碼',
  travel_group_type: '類型',
  travel_group: '旅行團',
  related_groups: '相關旅行團',
  group_code: '旅行團號',
  group_name: '團名',
  group_cover: '個團圖片',
  group_serial: '團次',
  group_block: '內頁區塊',
  block_name: '區塊名稱',
  name: '名稱',
  products_link: '科威連結',
  vat: '統一編號',
  english_name: '英文名稱',
  emergency_contact: '緊急聯絡人',
  emergency_phone: '緊急聯絡人電話',
  title: '顯示名稱',
  display_name: '顯示名稱',
  display_level: '顯示層級',
  topic: '標題',
  sub_title: '副標題',
  system_name: '功能名稱',
  line_id: 'Line ID',
  tel: '市話',
  service_tel: '專人服務電話',
  description: '描述',
  contact_person: '聯絡人',
  contacts: '聯絡資訊',
  contact_area: '地區',
  reservation_phone: '訂位電話',
  address: '地址',

  main_system: '主系統',
  sub_system: '子系統',

  collaborate: '企業',
  activities_involved: '已參與的企業活動',
  collaborate_activity: '企業活動',
  collaborate_subsidy_list: '補助列表',
  collaborate_group: '企業團',
  collaborate_name: '企業名稱',
  collaborate_group_code: '企業團號',
  collaborate_common_questions_group: '企業團(複製報名表)',
  collaborate_spot_questions_group: '企業團(複製自選行程)',
  activity_cover: '活動圖片',
  is_fill_order_detail: '匯入時是否填入及覆蓋訂單旅客資訊',
  show_remainder_quantity: '顯示剩餘名額',
  show_sign_up_quantity: '顯示報名人數',
  show_quota_free: '顯示免費名額數量',
  show_quota_free_remained: '顯示免費名額剩餘數量',
  show_quota_free_total: '顯示免費名額總數',
  show_download_files: '顯示檔案下載',
  show_doc_file: '顯示行程檔案下載',
  show_orientation_url: '顯示線上說明會連結',
  show_menu_url: '顯示說明手冊下載',
  show_product_feature: '顯示出團特色',
  show_total_fee: '顯示團費',
  show_bed_type: '顯示旅客類型選單',
  show_off_items: '顯示下架',
  only_show_specify_group: '只顯示已報名或指定的團',
  only_view_specify_group: '限看當團資料',
  open_spot: '預設打開自選行程描述',
  can_cancel_order: '會員可否自行退團',
  download: '下載',

  firm_order_pending: '待處理',
  firm_order_processing: '處理中',
  firm_order_complete: '已處理',

  area: '線別',
  subarea: '子區域',
  offer_subarea: '優惠分類',
  all_area: '全部線別',
  all_offer_subarea: '全部優惠分類',
  area_name: '線別名稱',
  area_code: '線別代碼',
  situation: '銷售狀態',
  situation_types: '銷售狀態列表',
  situation_action: '觸發',
  situation_action_a: '線上訂購',
  situation_action_b: '線上諮詢',
  situation_remind: '提示選單',
  member_role: '會員身份',
  member: '員工',
  manager: '福委',
  membership: '會員資格',
  member_status: '組別',
  group_type: '梯次',
  free_quota: '免費名額',
  max_quota: '最大名額',
  subsidy: '補助金額',
  home_top_show: '線別選單',
  is_promote: '首頁即時旅遊推薦',
  is_promote_count: '推薦數量',
  area_hot: '各館推薦',
  hide_price_description: '隱藏價錢文字',
  area_min_price: '最低原價限制',
  area_popup: '彈跳視窗',
  seconds: '秒數',
  url: '連結',
  web_site: '網站',
  fax: '傳真',
  area_code_perm: '線別權限',
  count: '數量',

  area_region: '線別分類',

  catalog: '類別',
  catalog_type: '類型',
  catalog_code: '類別代碼',
  catalog_name: '類別名稱',
  catalog_cover: '類別封面',
  operation_picture: '團控圖',
  operation_mobile_picture: '手機版',
  order_email: '訂單處理信箱',
  catalog_is_home: '各館首頁',
  catalog_is_sub_home: '各館次首頁',
  catalog_top_ad: '上方廣告區塊',
  catalog_bottom_ad: '下方廣告區塊',
  catalog_section: '版面管理',
  catalog_product: '類別團別',
  catalog_products: '團別列表',
  catalog_product_count: '團別數量',
  catalog_add_product: '加入團別',
  selected_catalogs: '已選擇分類',
  sync: '同步',
  sync_to_area: '同步至線別',

  product_type_graphic: '圖文陳列',
  product_type_text: '純文字陳列',
  is_show_products: '是否顯示團別',

  airline_code: '代碼',

  header: 'Header',
  footer: 'Footer',
  bottom: '下方',
  banner: '輪播圖',
  tourist_info: '觀光情報',
  travel_info: '旅遊資訊',
  has_video: '是否有影片？',
  youtube_id: 'Youtube ID',
  video: '影片',
  share_video: '影片分享',

  top_travel: '口碑好評',
  top_travel_group: '口碑好評旅行團',

  region_alias: '地區別名',
  area_alias: '處所別名',
  department_alias: '部門別名',
  section_alias: '課別別名',

  product: '團別',
  product_type: '團別類型',
  product_code: '團別代碼',
  product_name: '團別名稱',
  product_alias: '團別大標',
  product_remark: '團別描述',
  product_schedule_brief: '團別行程簡述',
  days: '天數',
  total_days: '總天數',
  day: '日序',
  operator_remark: '團控表備註',
  operator_remark_label: '新網站適用，顯示在團控表中，超過10字截斷。',
  operator_remark_max_length: '(超過10字截斷)',
  product_cover: '團別圖片',
  route_picture: '路線圖片',
  banner_picture: '內頁大圖',
  airline: '航空公司',
  picture: '圖片',
  mobile_picture: '手機版圖片',
  photo: '照片',
  tour_leader: '領隊',
  tour_leader_introduction: '自我介紹',
  tour_leader_languages: '語言專長',
  tour_leader_countries: '到訪國家',
  tour_leader_experience: '帶團經驗',
  pdf_url: 'PDF檔連結',
  external_url: '外部連結',
  orientation_url: '線上說明會連結',
  menu_url: '說明手冊連結',
  departure_status: '出發',
  departure_early: '早去',
  departure_noon: '午去',
  departure_night: '晚去',

  gift_type: '類型',
  gift: '贈品',
  gift_name: '贈品名稱',
  gift_quantity: '餘量',
  gift_low_quantity: '低數量',
  gift_stock: '庫存',
  gift_current_quantity: '目前數量',
  gift_stock_company: '公司庫存',
  gift_stock_vendor: '廠商庫存',
  gift_department: '掛帳部門',
  gift_employee: '掛帳業務',
  gift_user: '會員',
  gift_group: '旅行團',
  gift_sales: '主辦業務',
  gift_operator: '申請人',
  gift_consumable: '消耗品',
  gift_limit_times: '重複申請',
  gift_cost: '成本',
  gift_unit_cost: '成本/單',
  gift_net_price: '售價/單',
  gift_sale_price: '售價',
  gift_repurchase_price: '買回單價',
  gift_amount: '金額',
  gift_dividend_point: '兌換點數',
  gift_posts: '過帳歷史',
  gift_posting: '過帳',
  gift_selected_posting: '過帳贈品',
  gift_posting_month: '過帳年月',
  init_quantity: '期初數量',
  init_cost: '期初成本',
  init_average_cost: '期初單位成本',
  purchase_quantity: '進貨數量',
  purchase_cost: '進貨成本',
  sales_quantity: '銷貨數量',
  sales_cost: '銷貨成本',
  sales_amount: '銷貨總額',
  sales_profit: '銷貨利潤',
  adjust_quantity: '調整數量',
  adjust_cost: '調整成本',
  final_quantity: '期末數量',
  final_cost: '期末成本',
  average_cost: '平均單位成本',
  gift_purchase_create_again: '是否重打訂單?',

  gift_purchase_date: '進貨日期',
  gift_purchases: '進貨歷史',
  gift_purchase: '進貨處理',
  gift_generate_order: '單號',
  gift_import: '進貨',
  gift_imported: '已進貨',
  gift_void_voucher: '作廢',
  gift_clone_voucher: '複製',
  gift_order_number: '單號',
  gift_order_date: '單號日期',
  gift_voucher_number: '傳票',
  gift_voucher_date: '傳票日期',

  gift_transfer_management: '庫存管理',
  gift_transfer_date: '日期',
  gift_transfers: '轉入轉出歷史',
  gift_transfer_in: '轉入',
  gift_adjust: '調整',
  gift_transfer_show_void: '顯示作廢單',
  gift_transfer_import: '轉出到公司',
  gift_transfer_adjust: '調整公司數量',
  gift_transfer_quantity: '異動數量',
  gift_origin_quantity: '盤前數量',
  gift_final_quantity: '盤後數量',
  gift_origin_stock: '盤前廠商庫存',
  gift_final_stock: '盤後廠商庫存',
  gift_stock_type: '倉庫類型',
  gift_stock_type_company: '公司庫存',
  gift_stock_type_vendor: '廠商庫存',
  gift_modify_type: '處理類型',
  gift_modify_type_init: '初始數量',
  gift_modify_type_purchase: '進貨',
  gift_modify_type_export: '轉出到公司',
  gift_modify_type_import: '廠商轉入',
  gift_modify_type_void: '訂單作廢',
  gift_modify_type_adjust: '數量調整',

  gift_application: '申請',

  gift_application_number: '傳單號',
  gift_application_date: '申請日期',
  gift_application_type: '申請種類',
  gift_application_state: '狀態',
  gift_application_public: '公關品',
  gift_application_department: '部門',
  gift_application_request_quantity: '申請數量',
  gift_application_return_quantity: '退回數量',
  gift_application_final_quantity: '剩餘數量',
  gift_application_repurchase_quantity: '買回數量',
  gift_application_amount: '總金額',
  gift_application_apply_amount: '申請金額',
  gift_application_return_amount: '退回金額',
  gift_application_review_number: '審核單號',
  gift_application_cancel_number: '銷帳單號',
  gift_application_return_number: '退回單號',
  gift_application_remark: '摘要',

  gift_application_fit: 'FIT購買',
  gift_application_group: '團體購買',
  gift_application_repurchase: '公司買回',
  gift_application_return: '申請退回',
  gift_application_point: '點數兌換',
  gift_application_sale: '旅客自購',
  gift_application_redeem: '點數加價購',

  gift_application_new: '未送審',
  gift_application_pending: '待審',
  gift_application_reject: '退審',
  gift_application_audit: '審核通過',
  gift_application_approve: '通過',
  gift_application_void: '已作廢',
  gift_application_lock: '待銷帳',
  gift_application_cancel: '已銷帳',
  gift_application_delete: '已取消',

  gift_application_submit_date: '送審日期',
  gift_application_review_date: '審核日期',
  gift_application_void_date: '作廢日期',
  gift_application_cancel_date: '銷帳日期',

  gift_review: '審核單',
  gift_review_operator: '製單人',
  gift_review_sales: '主辦業務',
  gift_review_reviewer: '審核員',
  gift_review_accountant: '銷帳員',
  gift_review_voider: '作廢人員',
  gift_review_amount: '總金額',
  gift_review_void: '作廢',
  gift_review_cancel: '銷帳',
  gift_review_clone: '重新申請',
  gift_review_return: '申請退回',
  gift_review_print: '列印',
  gift_review_reject_reason: '退審原因',
  gift_review_void_reason: '作廢原因',
  gift_review_return_reason: '退回原因',

  gift_review_return_print: '列印退回單',
  gift_review_return_quantity: '退回數量',
  gift_review_return_total_quantity: '退回總數',
  gift_review_return_amount: '退回金額',
  gift_review_return_total_amount: '退回總金額',

  gift_updater: '異動者',
  gift_updated_at: '異動日期',

  year: '年份',
  month: '月份',
  january: '一月',
  february: '二月',
  march: '三月',
  april: '四月',
  may: '五月',
  june: '六月',
  july: '七月',
  august: '八月',
  september: '九月',
  october: '十月',
  november: '十一月',
  december: '十二月',

  group_status: '成團狀態',
  group_ok: '保證成團',
  group_ready: '即將成團',
  group_types: '團型',
  abroad_regular_group: '國外正規團',
  cruise_ship_group: '郵輪團',
  domestic_group: '國內正規團',
  self_organized_group: '自組團',
  project_discount_group: '專案優惠團',
  pak_group: 'PAK團',
  price_remark1: '團費包含',
  price_remark2: '團費不含',
  price_remark3: '費用說明',
  free: '免費',
  deposit: '訂金',
  fee: '團費',
  adult_fee: '成人價',
  adult_cost: '成人價',
  infant: '嬰兒價',
  baby_cost: '嬰兒價',
  child_cost: '孩童價',
  child_fee_bed: '孩童佔床(扣除)',
  child_fee: '孩童不佔床(扣除)',
  add_bed_fee: '加床價(扣除)',
  adult_tip: '成人提示',
  infant_tip: '嬰兒提示',
  baby_tip: '嬰兒提示',
  child_tip: '孩童提示',
  tip_fee: '小費',
  tip_included: '是否含小費',
  tax_fee: '稅金',
  tax_included: '是否含稅',
  visa_fee: '簽證費',
  visa_included: '是否含簽證費',
  visa_free: '免簽證',
  hide_price: '隱藏價錢',
  show_up: '價錢顯示「起」',
  departure_date: '出發日期',
  signup_deadline: '報名截止日',
  registration_range: '開放期間',
  quantity: '名額',
  child_age: '幾歲以下為孩童',
  baby_age: '幾歲以下為嬰兒',
  order_modify_time_limit: '資料異動期限(分鐘)',
  user_quantity: '員工報名人數',
  user_completed_quantity: '員工完成報名人數',
  signup_quantity: '報名人數',
  signup_completed_quantity: '完成報名人數',
  max_quantity: '最大人數',
  remainder_quantity: '剩餘名額',
  fulled: '滿團',
  has_fulled: '已滿團',
  not_fulled: '未滿團',
  expired: '截止',
  has_expired: '已截止',
  not_expired: '未截止',
  seo: 'SEO',
  seo_title: 'SEO標題',
  seo_description: 'SEO說明',
  seo_keyword: 'SEO關鍵字',
  travel_group_count: '旅行團數量',

  schedule: '子行程',
  breakfast_desc: '早餐描述',
  launch_desc: '午餐描述',
  dinner_desc: '晚餐描述',

  hotel: '旅館',
  stay_hotel: '住宿旅館',
  hotel_sort: '旅館排序',
  show_same: '顯示或同級',
  schedule_brief: '子行程內容',
  schedule_detail_topic: '貼心小提醒(標題)',
  schedule_detail_desc: '貼心小提醒(內文)',

  honey_moon: '蜜月',
  honey_moon_page: '蜜月專區',
  show_honey_moon: '蜜月專區露出',
  join: '加入',
  joined: '已加入',
  not_join: '未加入',
  show_home: '首頁露出',
  top_banner: '上方大圖',

  traffic: '交通航班',
  fly_schedule: '航班',
  fly_no: '班機代碼',
  effect_date: '生效日期',
  estimated_days: '預估天數',
  day_sort: '同天排序',
  traffic_direction: '班機去回',
  departure_time: '出發時間',
  departure_city: '出發城市',
  arrive_time: '到達時間',
  arrive_city: '到達城市',

  voyage: '郵輪航程',
  direction: '地點',
  checkin_time: '登船時間',
  gate_close_time: '關閘時間',

  continent_name: '洲',

  national_flag: '國家國旗',
  weather_list: '氣象設定',
  country: '國家',
  country_name: '國家名稱',
  country_template: '國家範本',
  country_flag: '國旗',

  region: '地區',
  region_name: '地區名稱',

  travel_area: '區域',
  travel_region: '地區',
  travel_zone: '分區',
  selected_zones: '已選取分區',

  city: '城市',
  city_name: '城市名稱',
  city_template: '城市範本',
  city_weather: '城市氣象',
  city_gmt: 'GMT時間',
  weather_country_list: '國家列表',
  weather_city_list: '城市列表',
  selected_cities: '已選取城市',

  question: '題目',
  common_question: '報名表題目',
  common_question_option: '報名表題目選項',
  option: '選項',
  option_name: '選項名稱',
  text: '填充題',
  spot_question: '行程題目',
  spot: '行程',
  note: '注意事項',
  feature: '特色',
  question_type: '題型',
  question_select: '單選',
  question_multi: '多選',
  question_fill: '填充',
  question_date: '日期',
  question_image: '圖檔',
  placeholder: '輸入提示',

  order: '訂單',
  order_no: '訂單號',
  details_free_count: '免費人數',
  details_count: '總人數',
  passengers_count: '人數',
  every_one: '每位',
  total_fee: '總金額',
  total_cost: '自費',
  is_free: '免費名額？',
  travel_fee: '旅團費',
  travel_cost: '旅團自費',
  commons_cost: '優惠費用',
  discount_limit: '團費折抵上限',
  spots_cost: '所選行程自費',
  gender: '性別',
  date_of_birth: '出生日期',
  age: '年齡(以出發日計算)',
  age_type: '身份',
  bed_type: '旅客類別',
  adult: '成人',
  child: '小孩',
  baby: '嬰兒',
  identity_number: '身分證字號',
  nationality: '國籍',
  relationship: '關係',
  home_address: '住家地址',
  passport_number: '護照號碼',
  passport_expire: '護照效期',
  passport_image: '護照影本',
  mobile_phone: '手機',
  phone_number: '手機號碼',
  company_tel: '公司電話',
  remark: '備註',
  signup_status: '報名狀態',
  signup_completed: '報名完成',
  signup_non_complete: '報名未完成',

  sales: '業務',
  order_date: '訂購日期',
  order_details: '訂單明細',
  order_designated_sales: '客戶指定',
  order_remark: '其他說明',
  order_sales: '負責業務',
  order_origin_sales: '原業務',
  order_total_fee: '團費總額',
  order_total_deposit: '訂金總額',
  order_company: '處理公司',
  order_add_log: '新增紀錄',
  order_process_log: '處理紀錄',
  order_process_time: '處理時間',
  order_process_status: '處理狀況',
  order_process_description: '記錄內容',
  order_no_process: '未處理',
  order_no_sales: '未指派',
  order_assign: '指派',
  order_assign_times: '指派次數',
  order_assign_time: '指派時間',
  order_operator: '指派人',
  order_assign_sales: '指派業務',
  order_process: '處理訂單',
  order_assign_log: '指派紀錄',
  order_notify_title: '通知信標題',
  order_notify_content: '通知信內容',
  assigned_order: '是否指定業務',
  assigned: '已指定業務',
  non_assigned: '未指定業務',
  receipt_type: '代轉開立方式',
  receipt_title: '代轉抬頭',
  receipt_address: '代轉寄送地址',
  tax_id: '統一編號',
  payment_options: '付款方式',
  payment_amount: '付款金額',
  payment_link: '付款連結',
  payment_datetime: '付款時間',
  payment_card_number: '付款卡號',

  inquiry_no: '諮詢單號',
  inquiry_detail: '諮詢行程',
  inquiry_remark: '諮詢內容',
  inquiry_date: '諮詢日期',
  inquiry_know_fantasy: '如何得知上順',
  inquiry_process: '處理諮詢單',
  process: '處理',

  cowell_group_code: '科威團號',

  demand_id: '需求單號',
  demand_subject: '需求主題',
  demand_items: '需求項目',
  demand_date: '需求日期',

  export_fields: '匯出欄位',
  update_items: '更新項目',

  detail_info: '詳細資料',
  abs_block: '廣告區塊',
  image_alt: '圖片替代文字',
  picture_upload_size: '圖片上傳大小(bit)',
  upload_size: '上傳大小',

  employee_code: '員工編號',
  employee: '員工',
  depart: '部門',
  position: '職位',
  permission: '權限',
  group: '群組',
  permission_group: '權限群組',
  company: '公司',
  companies: '分公司',
  all_company: '全部分公司',
  employee_name: '員工姓名',
  employee_status: '在職狀態',
  employee_resignation: '離職',
  employee_in_service: '在職',
  employee_start_date: '到職日',
  employee_is_web: '可接網單',
  employee_superior: '上司',
  jwt_token: 'JWT Token',

  blog_share: '旅遊分享',
  publish_date: '發表日期',
  issue_date: '發文日期',

  news: '活動新訊',
  news_type: '連結模式',
  news_link_type: '外連',
  news_normal_type: '一般內頁',
  news_blog_type: '部落格內頁',
  news_catalog: '分類',
  news_dates: '有效期間',

  blog: '部落格',
  blog_title: '標題',
  blog_source: '來源',
  blog_post: '部落格文章',
  blog_source_id: '來源編號',
  blog_source_updated_time: '來源更新時間',
  blog_publish_date: '發佈日期',
  page_view: '觀看數',
  blog_layout: '部落格版型',
  right_trips: '右方精選行程',
  full_page: '文章滿版(無精選行程)',

  edm: '電子報',
  edm_type: '連結模式',
  edm_link_type: '外連',
  edm_normal_type: '內頁',
  edm_issue_date: '出刊日期',

  subscription: '電子報訂閱',
  subscriber: '訂閱者',
  subscription_source: '來源',
  subscription_time: '訂閱日期',

  magazine: '線上DM',
  magazine_on: '最新',
  magazine_off: '未上架',
  magazine_date: '日期',
  magazine_page: '頁數',
  magazine_pages: '總頁數',
  magazine_cover: '封面',
  magazine_file: 'PDF',
  magazine_file_path: '路徑',
  magazine_file_name: '檔名',
  magazine_desc: '描述',
  magazine_link_list: '連結',
  magazine_content_list: '目錄',

  offer: '優惠',
  offer_type: '優惠區塊',
  offer_area_type: '線別優惠',
  offer_bank_type: '銀行優惠',
  offer_dates: '有效期間',

  leader: '領隊',
  satisfaction: '滿意度調查',
  customer: '客戶',
  customer_name: '客戶名稱',
  customer_fullname: '客戶姓名',
  head_shot: '大頭照',
  content: '內文',
  expired_info: '截止資訊',
  lecture: '旅遊講座',
  lecture_sequence: '報名順位',
  lecture_order: '旅遊報名',
  acquiring_email: '收單Email',
  in_charge: '負責人',
  know_from: '從何得知',
  signup_no: '報名單編號',
  apply_type: '報名方式',
  apply_type_inner: '內部報名',
  apply_type_outer: '開放報名',
  date: '日期',
  signup_date: '報名日期',
  signup_start_date: '開始報名',
  signup_end_date: '截止報名',
  tourism_news: '旅遊新訊',
  lecture_is_full: '是否額滿',
  lecture_apply_type: '報名方式',
  lecture_know_fantasy: '如何得知上順',
  lecture_notes: '客人留言',
  questionnaire: '問卷',
  design_questionnaire: '設計問卷',

  plan: '方案',

  traveler_type: '旅客類型',
  price: '價格',
  main_price: '主打價',
  main_plan: '主打',
  age_min: '最小年齡',
  age_max: '最大年齡',
  traveler_bed_type: '床位',
  traveler_bed_type_bed: '佔床',
  traveler_bed_type_no_bed: '不佔床',
  traveler_bed_type_add_bed: '加床',
  traveler_bed_type_infant: '嬰兒',

  page_seo_name: '頁面',
  page_seo_url: 'URL',
  page_seo_page_title: 'PageTitle',
  page_seo_meta_title: 'MetaTitle',
  page_seo_meta_keyword: 'MetaKeyword',
  page_seo_meta_description: 'MetaDescription',
  page_seo_top_message: '置頂訊息',

  attribute: '屬性',

  regular: '排序方式',
  pc: '電腦版',
  mobile: '手機版',
  link: '連結',
  confirmed: '認證',
  passed: '通過',
  unconfirmed: '未認證',
  connect: '關連',

  meeting: '會議',
  meeting_booking: '預約會議',
  meeting_booking_modify: '修改會議',
  meeting_type: '類型',
  meeting_type_briefing: '說明會',
  meeting_type_lesson: '上順教室',
  meeting_place_type: '地點類型',
  meeting_place: '地點',
  meeting_place_inner: '公司會議室',
  meeting_place_other: '外部',
  meeting_datetime: '日期時間',
  meeting_start_time: '開始時間',
  meeting_end_time: '結束時間',
  meeting_canceled: '會議取消成功',
  meeting_cancel_failed: '會議取消失敗',
  briefing: '說明會',
  lesson: '上順課程',
  place_inner: '公司會議室',
  place_other: '外部',
  meeting_employee: '舉辦人',
  meeting_sales: '承辦業務',
  lecturer: '講師',
  assistant: '助理',
  meeting_sales_tel: '業務電話',
  meeting_tel: '聯絡電話',
  meeting_desc: '說明',
  meeting_applicants: '報名列表',
  meeting_capacity: '預定人數',
  meeting_quantity: '報名人數',
  meeting_apply_at: '報名時間',
  meeting_remainder: '剩餘名額',
  meeting_is_full: '是否額滿',
  meeting_is_fulled: '額滿',
  meeting_is_expired: '截止',
  meeting_apply: '報名',
  meeting_apply_send: '送出',
  meeting_apply_list: '報名表',
  meeting_apply_modify: '修改報名表',
  meeting_apply_cancel: '取消報名',
  meeting_apply_canceled: '取消報名成功',
  meeting_apply_cancel_failed: '取消報名失敗',
  meeting_signup_deadline: '報名截止日',
  meal_provided: '供食',
  has_provide_meal: '是否供食',
  material: '教材',
  material_source: '教材來源',
  none: '無',

  meeting_room: '會議室',
  meeting_schedules: '會議',
  meeting_room_booking: '預約會議室',
  meeting_room_booking_single: '單次',
  meeting_room_booking_period: '週期',
  meeting_room_booking_modify: '修改預約時間',
  meeting_schedule_title: '會議名稱',
  meeting_schedule_desc: '說明',
  meeting_schedule_employee: '申請人',
  meeting_schedule_tel: '連絡電話',
  meeting_schedule_extension_number: '分機號碼',
  meeting_schedule_date_range: '日期區間',
  meeting_schedule_datetime: '日期時間',
  meeting_schedule_weekday: '每週',
  meeting_schedule_start_time: '開始時間',
  meeting_schedule_end_time: '結束時間',

  meeting_schedule_notify_type: '通知方式',
  meeting_schedule_notify_target: '通知對象',
  meeting_schedule_notify_type_none: '不通知',
  meeting_schedule_notify_type_all: '通知全公司',
  meeting_schedule_notify_type_specify: '指定對象',

  complaint: '客訴案件',
  complaint_number: '案件編號',
  complainant: '客訴人',
  complaint_name: '客訴人姓名',
  complaint_tel: '客訴人電話',
  complaint_email: '客訴人電子郵件',
  complaint_line: 'LINE/Messenger/Google評論顯示名稱',
  complaint_description: '案件說明',
  complaint_channel: '投訴管道',
  complaint_initial_contact_date: '最初聯繫日期',
  complaint_last_contact_date: '最新聯繫日期',
  customer_service_agent: '客服',
  origin_customer_service_agent: '原客服',
  product_manager: '產品負責部門',
  product_area: '產品線別',
  origin_product_manager: '原產品負責部門',
  origin_product_area: '原產品線別',
  personnel: '人員',
  handler: '處理者',

  publication_demand: '季刊需求',

  bank: '銀行',
  bank_number: '銀行代碼',
  branch_name: '分行名稱',
  short_name: '簡短名稱',
  account_name: '戶名',
  account_number: '銀行帳號',
  business_number: '統一編號',

  set_down: '下位移',
  set_right: '右位移',

  ga: {
    pagePath: '網頁',
    pageviews: '瀏覽量',
    uniquePageviews: '不重複瀏覽量'
  }
}

export const message = {
  my_profile: '個人資訊',
  login: '登入',
  logout: '登出',
  login_success: '登入成功',
  login_employee: '登入者',
  login_date: '登入日期',
  login_system: '登入後台',

  word_limit: '({0}字)',
  please_input: '請輸入',
  please_input_: '請輸入{0}',
  please_select: '請選擇',
  please_select_: '請選擇{0}',
  please_select_file: '請選擇檔案',
  please_select_pdf: '請選擇PDF檔案',
  please_select_picture: '請選擇圖檔',
  please_input_account: '請輸入會員帳號',
  please_input_password: '請輸入會員密碼',
  please_input_product_code: '請輸入團別代碼',
  please_input_group_code: '請輸入旅行團號',
  please_input_common_questions_group_code: '請輸入用來複製報名表的個團',
  please_input_spot_questions_group_code: '請輸入用來複製自選行程的個團',
  select: '選擇',
  upload_logo: '上傳商標',
  refresh: '重新整理',

  lastWeek: '最近一週',

  select_locales: '選擇語系',

  fantasy_backend: '上順後台',
  fantasy_system: '上順後台管理系統',
  tour_control: '團控',
  tour_control_table: '團控表',

  fetch_failed: '抓取{0}資料失敗',

  select_fields: '選擇欄位',
  rename_fields: '命名欄位',
  export: '匯出',
  export_reports: '匯出報表',
  export_traveler_reports: '匯出旅客報表',
  export_all_reports: '匯出旅客比對資料',
  export_activity: '匯出報名狀況',

  invalid_parameter: '無效參數',

  confirm_close: '修改尚未儲存，確定要關閉？',
  confirm_empty_plans: '確定不設定方案及價格?',
  confirm_empty_traveler_types: '確定不設定旅客類型？',
  can_not_delete_main_price: '設為主打價時無法刪除',
  can_not_delete_last_plan: '不可刪除最後一個方案！',

  confirm_approve_gift_review: '確定通過 {0}？',
  confirm_reject_gift_review: '確定退審 {0}？',
  confirm_void_gift_review: '確定作廢 {0}？',
  confirm_cancel_gift_review: '確定銷帳？',
  please_input_gift_review_reject_reason: '請輸入退審原因',
  please_input_gift_review_void_reason: '請輸入作廢原因',
  please_input_gift_review_cancel_number: '請輸入銷帳單號',
  please_input_gift_review_cancel_date: '請輸入銷帳日期',

  confirm_cancel_meeting: '確定取消？',
  confirm_cancel_meeting_: '確定取消「{name}」？'
}

export const validation = {
  welcome_back: '歡迎回來，{username}',
  required: '請輸入{attribute}',
  requiredIf: '請輸入{attribute}',
  required_select: '請選取{attribute}',
  required_choose: '請選擇{attribute}',
  required_check: '請勾選{attribute}',
  required_account: '務必填寫{attribute}(此資訊將作為登入帳號使用)',

  minLength: '{attribute} 不能小於 {min} 個字元',
  maxLength: '{attribute}  不能大於 {max} 個字元',
  minValue: '{attribute} 不得小於 {min}',
  maxValue: '{attribute} 不得大於 {max}',
  between: '{attribute} 須介於 {min} 至 {max}之間',
  alpha: '{attribute} 須以英文組成',
  alphaNum: '{attribute} 須以英數組成',
  numeric: '{attribute} 須為數字',
  integer: '{attribute} 須為整數',
  decimal: '{attribute} 須包含小數',
  email: '{attribute} 須為有效的電子信箱'
}

export default {
  attributes,
  message,
  validation
}
